import {ISearchPhraseParams} from "../../types/ISearchPhraseParams";

export default function castSearchPhraseParams(data: ISearchPhraseParams) {
    const offerType = data.type || null;
    const area_0 = parseSearchValue(data.area_0);
    const area_1 = parseSearchValue(data.area_1);
    const rooms_0 = parseSearchValue(data.rooms_0);
    const rooms_1 = parseSearchValue(data.rooms_1);
    const price_0 = parseSearchValue(data.price_0);
    const price_1 = parseSearchValue(data.price_1);
    const instalment = parseSearchValue(data.instalment);

    return {
        offerType,
        area_0,
        area_1,
        rooms_0,
        rooms_1,
        price_0,
        price_1,
        instalment
    };
}

function parseSearchValue(value: string | undefined) {
    if (!value) {
        return null;
    }

    return parseInt(value, 10);
}
